import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./styles/globals.css";

// import "@digitallabs/one-x-ui/styles.css";
import "./resourses/digitallabs/one-x-ui/styles.css";

import LayoutWrapper from "./components/layout/LayoutWrapper";

import AppLayout from "./components/layout/AppLayout";
import { LoaderProvider } from "./context/LoaderContext";
import GlobalLoader from "./components/loader/GlobalLoader";
import { appRouter } from "./constants/routerConstant";

import DMQLogin from "./medical-questionnaire/login/page";
import FormFilling from "./medical-questionnaire/form-filling/page";
import SubmissionComplete from "./medical-questionnaire/submission-complete/page";
import LinkExpired from "./medical-questionnaire/link-expired/page";
import AppDisclaimer from "./medical-questionnaire/appDisclamer/page";
import Maintenance from "./medical-questionnaire/maintainanceMode/page";

function App() {
  return (
    <LayoutWrapper>
      <LoaderProvider>
        <GlobalLoader />
        <Router>
          <AppLayout>
            <Routes>
              <Route path="/" element={<Navigate to={appRouter.DMQLogin} replace />} />
              <Route path={appRouter.DMQLogin} element={<DMQLogin />} />
              <Route path={appRouter.FormFilling} element={<FormFilling />} />
              <Route path={appRouter.SubmissionComplete} element={<SubmissionComplete />} />
              <Route path={appRouter.LinkExpired} element={<LinkExpired />} />
              <Route path={appRouter.AppDisclaimer} element={<AppDisclaimer />} />
              <Route path={appRouter.MaintenanceMode} element={<Maintenance />} />
              <Route path="*" element={<Navigate to={appRouter.DMQLogin} replace />} />
            </Routes>
          </AppLayout>
        </Router>
      </LoaderProvider>
    </LayoutWrapper>
  );
}

export default App;
